const texts = {
  initialPromptPlaceholder: 'Write any additional instructions for the workout plan...',
  placeholder: 'Write your prompt...',
  generating: 'Processing your request... This can take some time. Please wait.',
  errorProcessingWorkout: 'Error processing workout: {error}',
  initialPrompt: `
  Workout plan instructions:
  • Level of experience of the client: {clientLevel}
  • Duration of the total workout session: {sessionDuration}
  • Where the workout will be performed: {performedLocation}
  • Intensity level of the workout: {intensityLevel}
  • Expected format of the exercises: {exerciseFormat}
  • Style of the workout: {workoutStyle}
  • Focus areas of the workout: {focusAreas}
  • Limitations of the client's physical condition: {limitations}
  • Equipment available for the workout to be performed: {accessibleEquipment}

  Additional instructions: {additionalInstructions}
  `,
};

export default texts;
